"use client";

import { useCallback, useState } from "react";
import type { ExploreBriefCard } from "../../types";

export type StoriesMode = "horizontal" | "vertical";

export function useBriefsOverlay() {
  const [selectedBrief, setSelectedBrief] = useState<ExploreBriefCard | null>(
    null
  );
  const [dialogOpen, setDialogOpen] = useState(false);
  const [storiesOpen, setStoriesOpen] = useState(false);
  const [allViewed, setAllViewed] = useState(false);

  const handleBriefClick = useCallback((brief: ExploreBriefCard) => {
    setSelectedBrief(brief);
    setDialogOpen(true);
  }, []);

  const handlePlayAll = useCallback(() => {
    setStoriesOpen(true);
  }, []);

  const handleCloseStories = useCallback(() => {
    setStoriesOpen(false);
  }, []);

  const handleAllViewed = useCallback(() => {
    setAllViewed(true);
  }, []);

  return {
    selectedBrief,
    dialogOpen,
    setDialogOpen,
    storiesOpen,
    allViewed,
    handleBriefClick,
    handlePlayAll,
    handleCloseStories,
    handleAllViewed,
  };
}
